const DEFAULT_THEME_COLOR = "#254465";
const DEFAULT_THEME_BG_COLOR = "#e6f2fc";
const DEFAULT_THEME_GRADIENT = "linear-gradient(#3e6d8d, #121d30)";

function fromEnv(value, fallback) {
  if (value == null) return fallback;
  const trimmed = String(value)
    .trim()
    .replace(/^['"]|['"]$/g, "")
    .trim();
  return trimmed || fallback;
}

export const THEME_COLOR = fromEnv(
  process.env.REACT_APP_THEME_COLOR,
  DEFAULT_THEME_COLOR
);
export const THEME_BG_COLOR = fromEnv(
  process.env.REACT_APP_THEME_BG_COLOR,
  DEFAULT_THEME_BG_COLOR
);
export const THEME_GRADIENT = (() => {
  const value = fromEnv(
    process.env.REACT_APP_THEME_GRADIENT,
    DEFAULT_THEME_GRADIENT
  );
  // dotenv can truncate at `#`, leaving an unusable value like `linear-gradient(`
  if (/gradient\s*\(/i.test(value) && !value.includes(")")) {
    return DEFAULT_THEME_GRADIENT;
  }
  return value;
})();

export function applyThemeColor() {
  if (typeof document === "undefined") return;

  document.documentElement.style.setProperty("--theme-color", THEME_COLOR);
  document.documentElement.style.setProperty("--gray", THEME_COLOR);
  document.documentElement.style.setProperty("--theme-bg-color", THEME_BG_COLOR);
  document.documentElement.style.setProperty("--theme-gradient", THEME_GRADIENT);

  const styleId = "bp-theme-overrides";
  let styleEl = document.getElementById(styleId);
  if (!styleEl) {
    styleEl = document.createElement("style");
    styleEl.id = styleId;
    document.head.appendChild(styleEl);
  }
  // `background: var(--gradient)` is invalid at computed-value time because the
  // comma inside linear-gradient() is parsed as extra background layers.
  // Paint the gradient as background-image with the resolved value instead.
  styleEl.textContent = `
    :root {
      --theme-color: ${THEME_COLOR};
      --gray: ${THEME_COLOR};
      --theme-bg-color: ${THEME_BG_COLOR};
      --theme-gradient: ${THEME_GRADIENT};
    }
    .wrap-login100,
    .login100-form-btn {
      background-color: transparent !important;
      background-image: ${THEME_GRADIENT} !important;
    }
    .login100-form-btn::before {
      background-image: ${THEME_GRADIENT} !important;
    }
  `;
}
